// extracted by mini-css-extract-plugin
module.exports = {"link":"OrganizationSportsComponent_link__2_ReA","button":"OrganizationSportsComponent_button__2HEGe","sports":"OrganizationSportsComponent_sports__337B7"};